import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {WarningCircle} from '../../icons';
import './MainCards.scss';

// Texto de cada faltante dentro de la frase y de su botón. «Vincular», no «Conectar» (6zUFUONB):
// el botón suma al cliente una cuenta de la agencia, igual que las filas de la card.
const MISSING_COPY = {
    ga4: {name: ['client_panel.platforms_missing_ga4', 'GA4'],
          cta: ['client_panel.platforms_missing_ga4_cta', 'Vincular GA4']},
    store: {name: ['client_panel.platforms_missing_store', 'la tienda'],
            cta: ['client_panel.platforms_missing_store_cta', 'Vincular tienda']},
    ads: {name: ['client_panel.platforms_missing_ads', 'una cuenta de pauta'],
          cta: ['client_panel.platforms_missing_ads_cta', 'Vincular pauta']},
};

/**
 * Aviso de la card «Fuentes de datos» del Panel 2.1: qué fuentes esperables le faltan al cliente
 * (card RNAjmiW6; la regla está en `control_central/expectedPlatforms.js`).
 *
 * No se cierra: la salida es vincular la fuente o «Ignorar» el canal en la fila, que ya existe y
 * lo saca de la regla. Cada botón abre el mismo modal que la fila de ese canal; la pauta, que no es
 * un canal puntual, lleva a las conexiones del cliente.
 */
export function MissingPlatformsNotice({missing, clientId, onConnect}) {
    const {t, i18n} = useTranslation();
    if (!missing || missing.length === 0) return null;

    const names = missing.map(m => t(...MISSING_COPY[m.key].name));
    const list = new Intl.ListFormat(i18n.language === 'en' ? 'en' : 'es', {type: 'conjunction'}).format(names);

    return (
        <div className="pnl-banner pnl-missing" role="status">
            <WarningCircle size={18}/>
            <span className="pnl-banner__txt">
                {t('client_panel.platforms_missing_text', {
                    sources: list,
                    defaultValue: 'Falta vincular {{sources}}. Con todas las fuentes, la IA ve el panorama completo del cliente.',
                    interpolation: {escapeValue: false},
                })}
            </span>
            <span className="pnl-missing__actions">
                {missing.map(m => {
                    const label = t(...MISSING_COPY[m.key].cta);
                    return m.channel ? (
                        <button key={m.key} type="button" className="pnl-btn pnl-btn--ghost pnl-btn--sm"
                                onClick={() => onConnect(m.channel)}>
                            {label}
                        </button>
                    ) : (
                        <Link key={m.key} className="pnl-btn pnl-btn--ghost pnl-btn--sm"
                              to={`/client/${clientId}/conections`}>
                            {label}
                        </Link>
                    );
                })}
            </span>
        </div>
    );
}
